/* globals customElements, FileReader */
import { LitElement, html, css } from 'lit-element'
import ClipService from './clip-service'




//

//
const promptDetailDialog = document.getElementById('promptDetailDialog');
const promptP1 = document.getElementById('promptP1');
const promptP2 = document.getElementById('promptP2');
promptDetailDialog.addEventListener('close', () => {
});

export default class ClipFront extends LitElement {
  constructor () {
    super()
    window.fetch('config.json').then(res => res.json()).then(config => {
      this.defaultIndex = config.defaultIndex
      this.defaultBackend = config.defaultBackend
      this.urlColumn = config.urlColumn || 'url'
      this.init()
    })
  }

  init () {
    const urlParams = new URLSearchParams(window.location.search)
    const back = urlParams.get('back')
    const index = urlParams.get('index')
    const query = urlParams.get('query')
    const useMclip = urlParams.get('useMclip')
    const imageUrl = urlParams.get('imageUrl')
    if (index != null) {
      this.currentIndex = index
    } else {
      this.currentIndex = back === null || back === this.defaultBackend ? this.defaultIndex : ''
    }
    if (back != null) {
      this.backendHost = back
    } else {
      this.backendHost = this.defaultBackend
    }
    if (query != null) {
      this.text = query
    } else {
      this.text = ''
    }
    if (useMclip != null) {
      this.useMclip = useMclip === 'true'
    } else {
      this.useMclip = false
    }
    this.service = new ClipService(this.backendHost)
    this.numImages = 40
    this.numResultIds = 3000
    this.lastMetadataId = null
    this.onGoingMetadataFetch = false
    this.indices = []
    this.images = []
    this.modality = 'image'
    this.blacklist = {}
    this.lastSearch = 'text'
    this.displayCaptions = true
    this.displaySimilarities = false
    this.displayFullCaptions = false
    this.safeMode = true
    this.removeViolence = true
    this.firstLoad = true
    this.imageUrl = imageUrl === null ? undefined : imageUrl
    this.hideDuplicateUrls = true
    this.hideDuplicateImages = true
    this.aestheticScore = ''
    this.aestheticWeight = '0.5'
    this.scrollCount = 0
    this.initIndices()



  //   window.onload = function(){
  //     //获取需要悬浮的对象
  //     let show = this.shadowRoot.getElementById("aiType");
  //     //获取被隐藏的菜单
  //     let menu = this.shadowRoot.getElementById("aiTypeMenu");

  //     //给show添加鼠标悬浮事件
  //     show.onmouseover = function(){
  //         //改变菜单的内联样式display为block
  //         menu.style.display = "block";
  //     }

  //     //
  //     show.onmouseout = function(){
  //         //获取菜单栏的坐标值
  //         let menux = menu.offsetLeft;
  //         let menuy = menu.offsetTop;
  //         let menuX = menu.offsetLeft+menu.offsetWidth;
  //         let menuY = menu.offsetTop+menu.offsetHeight;

  //         //获取鼠标的坐标值
  //         let event = window.event;
  //         let mouseX = event.clientX;
  //         let mouseY = event.clientY;

  //         if(mouseX<menux || mouseX>menuX || mouseY<menuY || mouseY>menuY){
  //             menu.style.display = "none";
  //         }
  //     }

  //     //分别给menu对象绑定鼠标悬浮和鼠标离开事件
  //     menu.onmouseover = function(){
  //         menu.style.display = "block";
  //     }
  //     menu.onmouseleave = function(){
  //         menu.style.display = "none";
  //     }
  // }
    

    
  }

  setBackendToDefault () {
    this.backendHost = this.defaultBackend
    this.initIndices(true)
  }

  initIndices (forceChange) {
    this.service.getIndices().then(l => {
      this.indices = l
      if (forceChange || this.currentIndex === '') {
        this.currentIndex = this.indices[0]
      }
    }).catch(e => {
      console.error(e)
      if (!forceChange) {
        this.setBackendToDefault()
      }
    })
  }

  static get properties () {
    return {
      service: { type: Object },
      images: { type: Array },
      image: { type: String },
      imageUrl: { type: String },
      text: { type: String },
      numImages: { type: Number },
      modality: { type: String },
      indices: { type: Array },
      currentIndex: { type: String },
      backendHost: { type: String },
      blacklist: { type: Object },
      displaySimilarities: { type: Boolean },
      displayCaptions: { type: Boolean },
      displayFullCaptions: { type: Boolean },
      safeMode: { type: Boolean },
      removeViolence: { type: Boolean },
      hideDuplicateUrls: { type: Boolean },
      hideDuplicateImages: { type: Boolean },
      useMclip: { type: Boolean },
      aestheticWeight: { type: String },
      aestheticScore: { type: String },
      scrollCount: { type: Number },
      filterImages: { type: Array }
    }
  }

  firstUpdated () {
    const searchElem = this.shadowRoot.getElementById('searchBar')
    searchElem.addEventListener('keyup', e => { if (e.keyCode === 13) { this.textSearch() } })
    const productsElement = this.shadowRoot.getElementById('products')
    window.onscroll = () => {
      if ((window.innerHeight + window.pageYOffset) >= productsElement.offsetHeight) {
        this.fetchMoreMetadata()
        
      }
      // if ((window.innerHeight + window.pageYOffset) % productsElement.offsetHeight==0) {
      //   this.fetchMoreMetadata()
        
      // }
    }
  }

  async initialScroll () {
    const productsElement = this.shadowRoot.getElementById('products')
    let i = 0
    while ((window.innerHeight + window.pageYOffset) >= productsElement.offsetHeight) {
    // while ((window.innerHeight + window.pageYOffset) % productsElement.offsetHeight==0) {
      await this.fetchMoreMetadata()
      
      i += 1
      if (i > 5) {
        break
      }
    }
  }

  updated (_changedProperties) {
    if (_changedProperties.has('backendHost')) {
      this.service.backend = this.backendHost
      this.initIndices(!this.firstLoad)
      this.firstLoad = false
      this.setUrlParams()
    }
    if (_changedProperties.has('currentIndex')) {
      this.setUrlParams()
    }
    if (_changedProperties.has('image')) {
      if (this.image !== undefined) {
        this.imageSearch()
        return
      }
    }
    if (_changedProperties.has('imageUrl')) {
      if (this.imageUrl !== undefined) {
        this.imageUrlSearch()
        return
      }
    }
    if (_changedProperties.has('useMclip') || _changedProperties.has('modality') || _changedProperties.has('currentIndex') ||
     _changedProperties.has('hideDuplicateUrls') || _changedProperties.has('hideDuplicateImages') || _changedProperties.has('safeMode') ||
     _changedProperties.has('removeViolence') || _changedProperties.has('aestheticScore') || _changedProperties.has('aestheticWeight')) {
      if (this.image !== undefined || this.text !== '' || this.imageUrl !== undefined) {
        this.redoSearch()
      }
    }
  }

  async redoSearch () {
    if (this.lastSearch === 'text') {
      this.textSearch()
    } else if (this.lastSearch === 'image') {
      this.imageSearch()
    } else if (this.lastSearch === 'imageUrl') {
      this.imageUrlSearch()
    }
  }

  setUrlParams () {
    const urlParams = new URLSearchParams(window.location.search)
    if (this.text !== '') {
      urlParams.set('query', this.text)
    } else {
      urlParams.delete('query')
    }
    if (this.imageUrl !== undefined) {
      urlParams.set('imageUrl', this.imageUrl)
    } else {
      urlParams.delete('imageUrl')
    }
    urlParams.set('back', this.backendHost)
    urlParams.set('index', this.currentIndex)
    urlParams.set('useMclip', this.useMclip)
    window.history.pushState({}, '', '?' + urlParams.toString())
  }

  async fetchMoreMetadata (amount = 40) {
    if (this.lastSearch === 'text') {
      // this.scrollCount = this.scrollCount+1;
      // this.images = this.textSearch()
    }
    if (this.onGoingMetadataFetch) {
      return
    }
    this.onGoingMetadataFetch = true
    console.log('fetching more metadata starting from position', this.lastMetadataId)
    if (this.lastMetadataId === null) {
      this.onGoingMetadataFetch = false
      return
    }
    amount = Math.min(amount, this.numResultIds - this.lastMetadataId - 1)
    if (amount <= 0) {
      this.onGoingMetadataFetch = false
      return
    }
    const ids = this.images.slice(this.lastMetadataId + 1, this.lastMetadataId + amount + 1).map(i => i.id)
    try {
      const metasWithIds = Object.fromEntries((await this.service.getMetadata(ids, this.currentIndex)).map(({ id, metadata }) => [id, metadata]))
      this.images = this.images.map(image => {
        if (metasWithIds[image.id] !== undefined) {
          image = { ...metasWithIds[image.id], ...image }
        }
        return image
      })
      this.lastMetadataId += amount
    } catch (e) {
      console.log(e)
    }
    this.onGoingMetadataFetch = false
  }

  callClip (overrideCount = null) {
    const text = this.text === undefined ? null : this.text
    const image = this.image === undefined ? null : this.image
    const imageUrl = this.imageUrl === undefined ? null : this.imageUrl
    const numImages = overrideCount === null ? this.numImages : overrideCount
    const numResultIds = overrideCount === null ? this.numResultIds : overrideCount
    return this.service.callClipService(text, image, imageUrl, null, this.modality, numImages,
      this.currentIndex, numResultIds, this.useMclip, this.hideDuplicateImages, this.safeMode, this.removeViolence, this.aestheticScore, this.aestheticWeight,this.scrollCount)
  }

  artSearchCallClip (overrideCount = null) {
    const text = this.text === undefined ? null : this.text
    const image = this.image === undefined ? null : this.image
    const imageUrl = this.imageUrl === undefined ? null : this.imageUrl
    const numImages = overrideCount === null ? this.numImages : overrideCount
    const numResultIds = overrideCount === null ? this.numResultIds : overrideCount
    return this.service.callClipService(text, image, imageUrl, null, this.modality, numImages,
      this.currentIndex, numResultIds, this.useMclip, this.hideDuplicateImages, this.safeMode, this.removeViolence, this.aestheticScore, this.aestheticWeight,this.scrollCount)
  }

  async download () {
    function downloadFile (filename, text) {
      var element = document.createElement('a')
      element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(text))
      element.setAttribute('download', filename)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    }
    const count = this.modality === 'image' && this.currentIndex === this.indices[0] ? 10000 : 100
    const results = await this.callClip(count)
    downloadFile('clipsubset.json', JSON.stringify(results, null, 2))
  }

  async textSearch () {

    
    document.getElementById('loadingImg').style="display:block;z-index:9999;text-align:center;margin-left:50%;";
    if(this.shadowRoot.getElementById('figureimg')!=undefined){
      this.shadowRoot.getElementById('figureimg').style="display:inline;";
    }
    
    this.shadowRoot.getElementById('wordCloud').style="display:none;";
    //
    if (this.text === '') {
      return
    }
    this.image = undefined
    this.imageUrl = undefined
    const results = await this.callClip()
    console.log(results)
    document.getElementById('loadingImg').style="display:none;z-index:1;text-align:center;margin-left:50%;";
    this.images = results
    this.lastMetadataId = Math.min(this.numImages, results.length) - 1
    this.lastSearch = 'text'
    this.setUrlParams()
    setTimeout(() => this.initialScroll(), 0)
   
  }

  async artSearch () {


    document.getElementById('loadingImg').style="display:block;z-index:9999;text-align:center;margin-left:50%;";
    if(this.shadowRoot.getElementById('figureimg')!=undefined){
      this.shadowRoot.getElementById('figureimg').style="display:inline;";
    }
    
    this.shadowRoot.getElementById('wordCloud').style="display:none;";
    //
    if (this.text === '') {
      return
    }
    this.image = undefined
    this.imageUrl = undefined
    const results = await this.artSearchCallClip()
    console.log(results)
    document.getElementById('loadingImg').style="display:none;z-index:1;text-align:center;margin-left:50%;";
    this.images = results
    this.lastMetadataId = Math.min(this.numImages, results.length) - 1
    this.lastSearch = 'text'
    this.setUrlParams()
    setTimeout(() => this.initialScroll(), 0)
    
  }

  async imageSearch () {


    document.getElementById('loadingImg').style="display:block;z-index:9999;text-align:center;margin-left:50%;";
    if(this.shadowRoot.getElementById('figureimg')!=undefined){
      this.shadowRoot.getElementById('figureimg').style="display:inline;";
    }
    this.shadowRoot.getElementById('wordCloud').style="display:none;";
    //
    this.text = ''
    this.imageUrl = undefined
    const results = await this.callClip()
    console.log(results)
    document.getElementById('loadingImg').style="display:none;z-index:1;text-align:center;margin-left:50%;";
    this.images = results
    this.lastMetadataId = Math.min(this.numImages, results.length) - 1
    this.lastSearch = 'image'
    this.setUrlParams()
    setTimeout(() => this.initialScroll(), 0)
    
  }

  async imageUrlSearch () {


    document.getElementById('loadingImg').style="display:block;z-index:9999;text-align:center;margin-left:50%;";
    if(this.shadowRoot.getElementById('figureimg')!=undefined){
      this.shadowRoot.getElementById('figureimg').style="display:inline;";
    }
    this.shadowRoot.getElementById('wordCloud').style="display:none;";
    //
    this.text = ''
    this.image = undefined
    const results = await this.callClip()
    console.log(results)
    document.getElementById('loadingImg').style="display:none;z-index:1;text-align:center;margin-left:50%;";
    this.images = results
    this.lastMetadataId = Math.min(this.numImages, results.length) - 1
    this.lastSearch = 'imageUrl'
    this.setUrlParams()
    setTimeout(() => this.initialScroll(), 0)
    
  }

  painter007(){
    document.getElementById('generate-img-ui').style='display: none;';
    
    document.getElementById('generate-img-2-ui').style='display: none;';

    // window.location.replace('https://'+window.location.host+'/Stable-Diffusion-image-prompt-book.html')
    // window.open('https://'+window.location.host+'/Stable-Diffusion-image-prompt-book.html', '_blank');
    window.open('https://painter007.web.app', '_blank');

    
    
    // if(this.shadowRoot.getElementById('figureimg')!=undefined){
    //   this.shadowRoot.getElementById('figureimg').style="display:none;";
    // }
    // this.shadowRoot.getElementById('wordCloud').style="display:block;";
  }

  aiType(){
    document.getElementById('generate-img-ui').style='display: none;';
    
    document.getElementById('generate-img-2-ui').style='display: none;';

    // window.location.replace('https://'+window.location.host+'/Stable-Diffusion-image-prompt-book.html')
    // window.open('https://'+window.location.host+'/Stable-Diffusion-image-prompt-book.html', '_blank');
    window.open('https://sites.google.com/view/dream-style', '_blank');

    
    
    // if(this.shadowRoot.getElementById('figureimg')!=undefined){
    //   this.shadowRoot.getElementById('figureimg').style="display:none;";
    // }
    // this.shadowRoot.getElementById('wordCloud').style="display:block;";
  }

  art007(){
    document.getElementById('generate-img-ui').style='display: none;';
    
    document.getElementById('generate-img-2-ui').style='display: none;';

    // window.location.replace('https://'+window.location.host+'/Stable-Diffusion-image-prompt-book.html')
    // window.open('https://'+window.location.host+'/Stable-Diffusion-image-prompt-book.html', '_blank');
    window.open('https://pixeldraw007.web.app/', '_blank');

    
    
    // if(this.shadowRoot.getElementById('figureimg')!=undefined){
    //   this.shadowRoot.getElementById('figureimg').style="display:none;";
    // }
    // this.shadowRoot.getElementById('wordCloud').style="display:block;";
  }

  async subGenerate(referenceImageSrc){
    var yourLoginStateEle=document.getElementById('yourLoginState');
    var yourSubscribeStateEle=document.getElementById('yourSubscribeState');
    if(yourLoginStateEle.value=='0'){
      alert('please log in first')
      return;
    }
    // if(yourSubscribeStateEle.value=='0'){
    //   alert('Please go to the home page to subscribe')
    //   return;
    // }
    document.getElementById('referenceImageSrc').value=referenceImageSrc
    //
    // var referenceImageSrc=document.getElementById('referenceImageSrc').value;
    // var referenceImageHtml='<img id="referenceImage" src="'+referenceImageSrc+'"></img>';
    // GenerateImg2Class.shadowRoot.getElementById('referenceImages').innerHTML=referenceImageHtml
      
    //
    document.getElementById('generate-img-ui').style='display: none;';
    document.getElementById('clip-front').style='display: none;';
    document.getElementById('generate-img-2-ui').style='display: block;';
    
    
    
  }
  async subBookmark(){
    var yourLoginStateEle=document.getElementById('yourLoginState');
        if(yourLoginStateEle.value=='0'){
          alert('please log in first')
          return;
        }
        alert('temporarily unavailable') 
  }

  static get styles () {
    return css`
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
        -webkit-transition-delay: 9999s;
    }

    figcaption {
      display: table-caption;
      caption-side: bottom;
      background: #fff;
      padding: 0 0px 0px;
    }
    //html{
    //  background-color:#555;
    //}
    #searchBar, #searchBar:hover, #searchBar:focus, #searchBar:valid {
      border-radius: 25px;
      border-color: #ddd;
      background-color:white;
      border-width:1px;
      width:70%;
      padding:15px;
      padding-left:20px;
      outline: none;
      border-style: solid;
      font-size:16px;
      font-family:arial, sans-serif;
      margin-left:0.5%;
    }
    #searchBar:hover, #searchBar:focus {
      box-shadow: 0px 0px 7px  #ccc;
    }
    #all {
      margin-left:1%;
      margin-right:2%;
      margin-top: 22%;
    }
    #inputSearchBar:hover > #searchBar {
      box-shadow: 0px 0px 7px  #ccc !important;
    }
    #download {
      width: 30px;
      margin-left:0.5%;
      vertical-align:middle;
      cursor:pointer;
    }
    #generateImg {
      width: 30px;
      margin-left:0.5%;
      vertical-align:middle;
      cursor:pointer;
    }
    #aiType {
      width: 30px;
      margin-left:0%;
      vertical-align:middle;
      cursor:pointer;
    }
    #painter007{
      width: 30px;
      margin-left:0%;
      vertical-align:middle;
      cursor:pointer;
    }
    #art007{
      width: 30px;
      margin-left:0%;
      vertical-align:middle;
      cursor:pointer;
    }
    #imageSearch {
      width: 34px;
      margin-left:0.5%;
      vertical-align:middle;
      cursor:pointer;
    }
    #textSearch {
      width: 30px;
      margin-left:1.5%;
      vertical-align:middle;
      cursor:pointer;
    }
    #artSearch {
      width: 30px;
      margin-left:0.5%;
      vertical-align:middle;
      cursor:pointer;
    }
    .subImageSearch {
      width: 22px;
      height: 22px:
      cursor:pointer;
      float:right;
      z-index:90;
      display:None;
    }
    .subTextSearch {
      width: 22px;
      height: 22px:
      cursor:pointer;
      margin-left:5%;
      margin-right:5%;
      float:right;
      z-index:90;
      display:None;
    }
    .subPromptDetail {
      width: 22px;
      height: 22px:
      cursor:pointer;
      margin-left:5%;
      margin-right:5%;
      float:right;
      z-index:90;
      display:None;
    }
    .subImageShare {
      width: 22px;
      height: 22px:
      cursor:pointer;
      margin-left:5%;
      margin-right:5%;
      float:right;
      z-index:90;
      display:None;
    }
    .subGenerate {
      width: 22px;
      height: 22px:
      cursor:pointer;
      margin-left:5%;
      margin-right:5%;
      float:right;
      z-index:90;
    }
    .subBookmark {
      width: 22px;
      height: 22px:
      cursor:pointer;
      margin-left:5%;
      margin-right:5%;
      float:right;
      z-index:90;
    }
    figure:hover > .subImageSearch {
      display:inline;
      cursor:pointer;
    }
    figure:hover > .subTextSearch {
      display:inline;
      cursor:pointer;
    }
    figure:hover > .subPromptDetail {
      display:inline;
      cursor:pointer;
    }
    figure:hover > .subImageShare {
      display:inline;
      cursor:pointer;
    }

    figure:hover > .subGenerate {
      display:inline;
      cursor:pointer;
    }

    figure:hover > .subBookmark {
      display:inline;
      cursor:pointer;
    }

    // #aiType:hover > .subImageSearch {
    //   display:inline;
    //   cursor:pointer;
    // }
    // #aiType:hover > .subTextSearch {
    //   display:inline;
    //   cursor:pointer;
    // }
    
    #products {
      margin-top:50px;
      width:84%;
      float:left;
      margin-left:11.5%;

      display: inline-grid;
    }
    @media (min-width: 500px) {
      #products {
        grid-template-columns: repeat(2, 1fr);
      }
    }
    
    @media (min-width: 750px) {
      #products{
        grid-template-columns: repeat(3, 1fr);
      }
    }
    
    @media (min-width: 1000px) {
      #products {
        grid-template-columns: repeat(3, 1fr);
      }
    }
    
    @media (min-width: 1300px) {
      #products {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    
    @media (min-width: 1600px) {
      #products{
        grid-template-columns: repeat(5, 1fr);
      }
    }
    @media (min-width: 3200px) {
      #products{
        grid-template-columns: repeat(10, 1fr);
      }
    }
    #filter {
      position:absolute;
      top:80%;
      width:10%;
      float:left;
    }
    #searchLine {
      margin-left:9%;
    }

    figcaption {
      font-size:16px;
    }

    figure,img.pic,figcaption {
      width:250px;
    }

    @media (max-width: 500px) {

      #searchBar, #searchBar:hover, #searchBar:focus, #searchBar:valid {
        width:55%;
      }
      #filter {
        font-size:14px;
        width:100px;
      }

      #products {
        grid-template-columns: repeat(3, 1fr);
      }
      figure,img.pic,figcaption {
      width:70px;
      }

      figcaption {
        font-size:12px;
      }

    #products {
      width:60%;
    }
    }


    li{
      list-style: none;
  }
  #aiTypeMenu{
      display: none;
      margin-left: 10px;
      width: 50px;
      border: 1px solid #ccc;
      background: rgba(0, 0, 0, 0.6);
  }
  #aiTypeMenu a{
      color: #fff;
      text-decoration: none;
  }




  ul.cloud {
    list-style: none;
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    line-height: 2.75rem;
    width: 80%;
    height: 60%;
    margin-left: 10%;
margin-top: 5%;
    /* width: 450px; */
  }
  
  ul.cloud a {
    /*   
    Not supported by any browser at the moment :(
    --size: attr(data-weight number); 
    */
    --size: 4;
    --color: #a33;
    color: var(--color);
    font-size: calc(var(--size) * 0.25rem + 0.5rem);
    display: block;
    padding: 0.125rem 0.25rem;
    position: relative;
    text-decoration: none;
    /* 
    For different tones of a single color
    opacity: calc((15 - (9 - var(--size))) / 15); 
    */
  }
  
  ul.cloud a[data-weight="1"] { --size: 1; }
  ul.cloud a[data-weight="2"] { --size: 2; }
  ul.cloud a[data-weight="3"] { --size: 3; }
  ul.cloud a[data-weight="4"] { --size: 4; }
  ul.cloud a[data-weight="5"] { --size: 6; }
  ul.cloud a[data-weight="6"] { --size: 8; }
  ul.cloud a[data-weight="7"] { --size: 10; }
  ul.cloud a[data-weight="8"] { --size: 13; }
  ul.cloud a[data-weight="9"] { --size: 16; }
  
  ul[data-show-value] a::after {
    content: " (" attr(data-weight) ")";
    font-size: 1rem;
  }
  
  ul.cloud li:nth-child(2n+1) a { --color: #181; }
  ul.cloud li:nth-child(3n+1) a { --color: #33a; }
  ul.cloud li:nth-child(4n+1) a { --color: #c38; }
  
  ul.cloud a:focus {
    outline: 1px dashed;
  }
  
  ul.cloud a::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 100%;
    background: var(--color);
    transform: translate(-50%, 0);
    opacity: 0.15;
    transition: width 0.25s;
  }
  
  ul.cloud a:focus::before,
  ul.cloud a:hover::before {
    width: 100%;
  }
  
  @media (prefers-reduced-motion) {
    ul.cloud * {
      transition: none !important;
    }
  }
    `
  }

  updateImage (file) {
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      this.image = reader.result.split(',')[1]
    }
    reader.onerror = (error) => {
      console.log('Error: ', error)
    }
  }

  renderImage (image) {
    let src
    if (image['image'] !== undefined) {
      src = `data:image/png;base64, ${image['image']}`
    }
    if (image[this.urlColumn] !== undefined) {
      src = image[this.urlColumn]
    }
    /*
    // useful for testing broken images
    const hashCode = s => s.split('').reduce((a,b)=>{a=((a<<5)-a)+b.charCodeAt(0);return a&a},0)

    const disp =  hashCode(src) % 2 == 0
    src = (disp ? "" : "sss") +src
    */
    return html`
    <figure id="figureimg" style="margin:5px;display:table" 
    style=${'margin:1px; ' + (this.blacklist[src] !== undefined ? 'display:none' : 'display:inline')}>
     ${this.displaySimilarities ? html`<p>${(image['similarity']).toFixed(4)}</p>` : ``}
      ${image['caption'] !== undefined
    ? html`
    <img src="assets/share.png" class="subImageShare" @click=${() => {
      
    }} />
    <img src="assets/search.png" class="subTextSearch" @click=${() => { this.text = image['caption']; this.textSearch() }} />` : ``}
     
     <img src="assets/image-search.png" class="subImageSearch" @click=${() => {
    if (image['image'] !== undefined) {
      this.image = image['image']
    } else if (image[this.urlColumn] !== undefined) {
      this.imageUrl = image[this.urlColumn]
    }
  }} />
    &nbsp;
    <img src="assets/more-details.png" class="subPromptDetail" @click=${() => {
      if (image['promptDetail'] !== undefined) {
        if (typeof promptDetailDialog.showModal === "function") {
          
          document.getElementById("promptP1").innerHTML = 'AI stable diffusion prompt:<br/>'+image['caption'];
          document.getElementById("promptP2").innerHTML = image['promptDetail'];
          document.getElementById("confirmBtn").style="display:block;"
          document.getElementById("promptDetailDialog").showModal();
        }
      } else{
        if (typeof promptDetailDialog.showModal === "function") {
          
          document.getElementById("promptP1").innerHTML = 'similar image search prompt:<br/>';
          document.getElementById("promptP2").innerHTML = image['caption'];
          document.getElementById("confirmBtn").style="display:block;"
          document.getElementById("promptDetailDialog").showModal();
        }
      }
    }} />

     <img class="pic" src="${src}" alt="${image['caption'] !== undefined ? image['caption'] : ''}"" 
      title="${image['caption'] !== undefined ? image['caption'] : ''}"
      @error=${() => { this.blacklist = { ...this.blacklist, ...{ [src]: true } } }} />

      ${this.displayCaptions ? html`<figcaption>
      ${image['caption'] !== undefined && image['caption'].length > 50 &&
      !this.displayFullCaptions ? image['caption'].substr(0, 50) + '...' : image['caption']}</figcaption>` : ''}
    
      <img src="assets/icons8-add-100.png" class="subGenerate" @click=${() => {
        if (image['image'] !== undefined) {
          document.getElementById('referenceImageSrc').value=image['image']
          this.subGenerate(image['image'])
        } else if (image[this.urlColumn] !== undefined) {
          document.getElementById('referenceImageSrc').value=image[this.urlColumn]
          this.subGenerate(image[this.urlColumn])
        }
        
        
      }} />
      <img src="assets/bookmark.png" class="subBookmark" @click=${() => {
        this.subBookmark()
      }} />
    
    </figure>
    `
  }

  filterDuplicateUrls (images) {
    const urls = {}
    return images.filter(image => {
      if (image[this.urlColumn] !== undefined) {
        if (urls[image[this.urlColumn]] === undefined) {
          urls[image[this.urlColumn]] = true
          return true
        }
        return false
      }
      return true
    })
  }


  render () {
    const preFiltered = this.images
      .filter(image => image['caption'] !== undefined || image[this.urlColumn] !== undefined || image['image'] !== undefined)
    const filteredImages = this.hideDuplicateUrls ? this.filterDuplicateUrls(preFiltered) : preFiltered
    this.filterImages = filteredImages

    //todo 下載元數據
    // <img src="assets/download.png" id="download" @click=${() => { this.download() }} />
    //     
    //todo 生成圖片
    // <img src="assets/icons8-add-100-2.png" id="generateImg" @click=${() => {
            
    // }} />

    return html`
    <div id="all">
    <div id="searchLine">
      <span id="inputSearchBar">
        <img src="assets/effect.png" id="painter007" @click=${() => { this.painter007() }} />
        <img src="assets/lightbulb.png" id="aiType" @click=${() => { this.aiType() }} />
        
        <img src="assets/lamp.png" id="art007" @click=${() => { this.art007() }} />

        <ul id="aiTypeMenu">
              <li><a href="#">choose 1</a></li>
              <li><a href="#">choose 2</a></li>
              <li><a href="#">choose3</a></li>
          </ul>
        <input id="searchBar" type="text" placeholder="Mona Lisa" .value=${this.text} @input=${e => { this.text = e.target.value }}/>
        <img src="assets/icons8-detective-100.png" id="textSearch" @click=${() => { this.textSearch() }} />
        <img src="assets/lollipop1.png" id="artSearch" @click=${() => { this.textSearch() }} />
        <img src="assets/icons8-upload-to-cloud-64.png" id="imageSearch" @click=${() => { this.shadowRoot.getElementById('filechooser').click() }} />
        <input type="file" id="filechooser" style="position:absolute;top:-100px;display: none;" @change=${() =>
          this.updateImage(this.shadowRoot.getElementById('filechooser').files[0])}>
        

      </span>

    </div>
        
    <div id="filter">
    
      ${this.image !== undefined ? html`<img style="min-width:90px;max-width:120px;" src="data:image/png;base64, ${this.image}"" /><br />` : ``}
      ${this.imageUrl !== undefined ? html`<img style="min-width:90px;max-width:120px;" src="${this.imageUrl}"" /><br />` : ``}
      
      
     </div>

    <div id="products">
    
    ${filteredImages.map(image => this.renderImage(image))}
    ${this.safeMode && this.images.length !== 0 && filteredImages.length === 0 ? 'Displaying only nice pictures in safe mode!' : ''}
    </div>

    </div>


    <ul id="wordCloud" class="cloud" role="navigation" aria-label="Webdev word cloud">
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Space',this.textSearch() }} data-weight="4" value="Space">Space</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Environments',this.textSearch() }} data-weight="1" value="Environments">Environments</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Cute',this.textSearch() }} data-weight="5" value="Cute">Cute</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Clay',this.textSearch() }} data-weight="8" value="Clay">Clay</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Accessory',this.textSearch() }} data-weight="6" value="Accessory">Accessory</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Toys',this.textSearch() }} data-weight="4" value="Toys">Toys</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Games',this.textSearch() }} data-weight="5" value="Games">Games</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Typography',this.textSearch() }} data-weight="6" value="Typography">Typography</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Cartoon',this.textSearch() }} data-weight="2" value="Cartoon">Cartoon</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Photograph',this.textSearch() }} data-weight="9" value="Photograph">Photograph</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Concept Art',this.textSearch() }} data-weight="3" value="Concept Art">Concept Art</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Funny',this.textSearch() }} data-weight="7" value="Funny">Funny</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Planets',this.textSearch() }} data-weight="8" value="Planets">Planets</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Science Fiction',this.textSearch() }} data-weight="1" value="Science Fiction">Science Fiction</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Celebrity',this.textSearch() }} data-weight="3" value="Celebrity">Celebrity</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Patterns',this.textSearch() }} data-weight="3" value="Patterns">Patterns</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Landscapes',this.textSearch() }} data-weight="7" value="Landscapes">Landscapes</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Sketch',this.textSearch() }} data-weight="8" value="Sketch">Sketch</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Portraits',this.textSearch() }} data-weight="1" value="Portraits">Portraits</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'People',this.textSearch() }} data-weight="3" value="People">People</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Wallpaper',this.textSearch() }} data-weight="4" value="Wallpaper">Wallpaper</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Sprites',this.textSearch() }} data-weight="1" value="Sprites">Sprites</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Logos',this.textSearch() }} data-weight="5" value="Logos">Logos</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Product Design',this.textSearch() }} data-weight="8" value="Product Design">Product Design</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Avatars',this.textSearch() }} data-weight="6" value="Avatars">Avatars</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Psychedelic',this.textSearch() }} data-weight="4" value="Psychedelic">Psychedelic</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Drawing',this.textSearch() }} data-weight="5" value="Drawing">Drawing</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Plants',this.textSearch() }} data-weight="6" value="Plants">Plants</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Animals',this.textSearch() }} data-weight="10" value="Animals">Animals</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Pottery',this.textSearch() }} data-weight="8" value="Pottery">Pottery</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Tattoo',this.textSearch() }} data-weight="6" value="Tattoo">Tattoo</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Pixel Art',this.textSearch() }} data-weight="4" value="Pixel Art">Pixel Art</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Diorama',this.textSearch() }} data-weight="2" value="Diorama">Diorama</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Clothes',this.textSearch() }} data-weight="6" value="Clothes">Clothes</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Jewelry',this.textSearch() }} data-weight="2" value="Jewelry">Jewelry</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = '3D',this.textSearch() }} data-weight="9" value="3D">3D</a></li>
      <li><a href="javascript:void(0);" @click=${() => { this.text = 'Cyberpunk',this.textSearch() }} data-weight="8" value="Cyberpunk">Cyberpunk</a></li>
    </ul>
    `
  }

}



